import structuredClone from '@ungap/structured-clone';

globalThis.structuredClone = globalThis.structuredClone || structuredClone;
